<div class="ussd">
  <app-status-bar [carrierName]="carrier" />

  <p class="ussd__code">{{ dialedCode }}</p>

  <!-- One persistent live region: the stage below is swapped out on every turn,
       and regions inserted with their text are not reliably announced. -->
  <p class="bk-sr-only" role="status">{{ announcement }}</p>

  <div class="ussd__stage">
    @if (isLoading) {
      <div class="ussd__running">
        <span class="bk-sym ussd__pulse" aria-hidden="true">more_horiz</span>
        <span>USSD code running…</span>
      </div>
    } @else {
      <div
        class="ussd__dialog"
        role="dialog"
        aria-labelledby="ussd-dialog-text"
        [class.is-error]="isError"
      >
        @if (isError) {
          <p class="ussd__flag">
            <span class="ussd__dot" aria-hidden="true"></span>
            Request failed
          </p>
        }
        <p class="ussd__text" id="ussd-dialog-text">{{ message || (isSessionEnd ? 'Session ended.' : '') }}</p>

        @if (awaitingReply) {
          <label class="bk-sr-only" for="ussd-reply">Your reply</label>
          <input
            #replyInput
            id="ussd-reply"
            class="ussd__input"
            type="text"
            inputmode="text"
            autocomplete="off"
            spellcheck="false"
            placeholder="Reply"
            [(ngModel)]="userInput"
            (keydown)="onReplyKeydown($event)"
          />
        }

        <div class="ussd__actions">
          @if (awaitingReply) {
            <button type="button" class="ussd__btn" (click)="cancel.emit()">Cancel</button>
            <button type="button" class="ussd__btn ussd__btn--main" [disabled]="!userInput.trim()" (click)="handleSend()">
              Send
            </button>
          } @else {
            <button #okBtn type="button" class="ussd__btn ussd__btn--main ussd__btn--wide" (click)="cancel.emit()">OK</button>
          }
        </div>
      </div>
    }
  </div>

  <button type="button" class="ussd__home" aria-label="Home: hang up" (click)="home.emit()">
    <span class="ussd__home-bar" aria-hidden="true"></span>
  </button>
</div>
